import { observer } from 'mobx-react';

import style from './Bottom.module.scss';

import { ActionButton, ActionButtonProps } from './ActionButton';
import { EditEntryData, EditEntryDataProps } from './EditEntryData';
import { EntryPageTestAttributes } from 'chaika-test-attributes';
import { Button, ButtonTheme } from '@components/Button';
import { translate } from '@chaika/i18n/helper';
import { TranslationSelect } from '@patient/ui/shared/TranslationSelect';
import { store } from '@store';

export interface BottomProps extends EditEntryDataProps {}

interface Props extends BottomProps {
    actionButtonProps: ActionButtonProps;
    onOpenHistoryClick(): void;
}

export const Bottom = observer(({ actionButtonProps, onEntryTypeSelect }: Props) => {
    const { entry } = store;

    const confirmedTranslations = entry.translations.values.filter(item => item.isConfirmed);

    function onBackClick() {
        entry.isTranslationMode = false;
    }

    return (
        <div className={style.root}>
            <div className={style.left}>
                <EditEntryData onEntryTypeSelect={onEntryTypeSelect} />
            </div>
            <div className={style.center}>
                {entry.isTranslationMode ? (
                    <Button
                        dataTest={EntryPageTestAttributes.BackButton}
                        theme={ButtonTheme.Secondary}
                        label={translate('returnToEntry')}
                        onClick={onBackClick}
                    />
                ) : (
                    <>
                        {confirmedTranslations.length > 0 && (
                            <TranslationSelect confirmedTranslations={confirmedTranslations} />
                        )}
                        <div className={style.actionButton}>
                            <ActionButton {...actionButtonProps} />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
});
